import { rgba } from 'polished';
import styled from 'styled-components';

/**
 * Branded hero strip used across page tops (Orders, Warehouse, Failed
 * Orders, Customers). Soft navy→yellow tint with a faint Sandoog box
 * mark tucked into the top-right corner — sized small + masked so
 * action buttons sitting on the right read cleanly above it.
 */
export const StyledPageHero = styled.div`
  position: relative;
  padding: 1.25rem 1.5rem;
  margin-bottom: 1.5rem;
  border-radius: 0.875rem;
  background: linear-gradient(
    135deg,
    ${({ theme }) => rgba(theme.colors.brand.navy, 0.04)} 0%,
    ${({ theme }) => rgba(theme.colors.brand.yellow, 0.06)} 100%
  );
  overflow: hidden;
  display: flex;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;

  /* Decorative box mark — small + masked + pushed off the corner so
     it reads as a brand-tinted texture rather than a competing
     graphic. The mask gradient fades the mark out as it approaches
     the button area on the right edge. */
  &::before {
    content: '';
    position: absolute;
    top: -2.5rem;
    right: -3.25rem;
    width: 8rem;
    height: 8rem;
    background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 240 280' fill='none'><g stroke='%23090F38' stroke-width='1.6' stroke-linejoin='round' stroke-linecap='round' opacity='0.18'><path d='M40 80l60-30 60 30v60l-60 30-60-30z'/><path d='M40 80l60 30M160 80l-60 30M100 110v60'/><path d='M30 70l-12-3M30 70l-10 8M40 80l-18-2'/></g></svg>");
    background-repeat: no-repeat;
    background-size: contain;
    opacity: 0.55;
    -webkit-mask-image: linear-gradient(
      225deg,
      rgba(0, 0, 0, 1) 0%,
      rgba(0, 0, 0, 0.7) 35%,
      rgba(0, 0, 0, 0) 75%
    );
    mask-image: linear-gradient(
      225deg,
      rgba(0, 0, 0, 1) 0%,
      rgba(0, 0, 0, 0.7) 35%,
      rgba(0, 0, 0, 0) 75%
    );
    pointer-events: none;
  }

  > * {
    position: relative;
    z-index: 1;
  }
`;

export const StyledPageHeroSpacer = styled.div`
  flex: 1;
`;
